import React, { useState } from "react";
import VerfiyUser from "./VerfiyUser";
import { useParams } from "react-router-dom";
import SubmitOTP from "./SubmitOTP";
import ChangePasswordOTP from "./ChangePasswordOTP";

function RecoverNewPassword() {

    const [step, setStep] = useState("VERIFY_USER");
    const { jwt } = useParams();

    const handleVerifyUser = () => {
        setStep("SUBMIT_OTP");
    };

    const handleSubmitOtp = () => {
        setStep("CHANGE_PASSWORD");
    };

    const renderStepComponent = () => {
        switch (step) {
            case "VERIFY_USER":
                return <VerfiyUser handleVerifyUser={handleVerifyUser} jwt={jwt} />;
            case "SUBMIT_OTP":
                return <SubmitOTP handleSubmitOtp={handleSubmitOtp} jwtToken={jwt} />;
            case "CHANGE_PASSWORD":
                return <ChangePasswordOTP jwt={jwt} />;
            default:
                return null;
        }
    };

    return <>{renderStepComponent()}</>;
}

export default RecoverNewPassword;
